module.exports = __webpack_public_path__ + "static/media/arrowDownBlue.b1cb94ce.svg";